// import React from 'react'
import ReactDOM from 'react-dom/client'
import {BrowserRouter} from 'react-router-dom'
import {Provider} from 'react-redux'
import {ConfigProvider} from 'contexts/config'
import store from './reduxStore/store'
import App from './app'

import './styles/custom.scss'
import {KanbanProvider} from 'contexts/kanban'
// import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ConfigProvider>
      <KanbanProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </KanbanProvider>
    </ConfigProvider>
  </Provider>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
